import Vue from 'vue';
var baseOptions ={
  //hubus:new Vue(),
  _self:this,
  //query:this.route.query
};

export default baseOptions
